/*
  GiftGo category drawer pane switching.

  The drawer's open/close is handled by Dawn's <header-drawer> / MenuDrawer.
  This element only switches the active category: tapping a left-rail tab shows
  the matching right-hand product panel. Vanilla, no dependencies. With no JS
  the first panel is visible and every "See all" link still navigates.
*/
(function () {
  'use strict';

  class GiftGoCats extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-gcat-tab]'));
      this.views = Array.prototype.slice.call(this.querySelectorAll('[data-gcat-view]'));
      if (!this.tabs.length) return;

      this.tabs.forEach(
        function (tab) {
          var idx = tab.getAttribute('data-gcat-tab');
          // Tapping/clicking a category navigates to its collection (native
          // anchor). On desktop, hovering previews that category's products.
          tab.addEventListener('mouseenter', this.activate.bind(this, idx));
        }.bind(this)
      );
    }

    activate(idx) {
      this.tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-gcat-tab') === idx;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.views.forEach(function (view) {
        var on = view.getAttribute('data-gcat-view') === idx;
        view.classList.toggle('is-active', on);
        view.hidden = !on;
      });
    }
  }

  if (!customElements.get('giftgo-cats')) {
    customElements.define('giftgo-cats', GiftGoCats);
  }
})();
